import {Directive, ElementRef, inject, Input, OnInit, Renderer2} from '@angular/core';
import {UserPermissionsService} from '../../../core/services/user-permissions.service';

@Directive({
  selector: '[pasAccessitem]',
  standalone: true
})
export class AccessitemDirective implements OnInit {
  @Input('pasAccessitem') pasAccessitem?: keyof AccessToGuides;

  permissionsService = inject(UserPermissionsService);
  elementRef = inject(ElementRef);
  renderer = inject(Renderer2);
  show = false;

  ngOnInit(): void {
    if (!this.elementRef.nativeElement) return

    this.permissionsService.permissons$.subscribe(v => {
      const view = v?.view
      if (this.pasAccessitem && view && view?.[this.pasAccessitem]) {
        this.show = true;
      } else {
        this.show = false;
      }
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', this.show ? '' : 'none')
      ;
    })

  }

}
